import React, { PureComponent } from 'react';
import styled from 'styled-components';

import { TABS } from '../../constants';
import { COLORS, FONT_FAMILIES } from 'shared/constants/theme';

const Wrapper = styled.form`
  display: flex;
  justify-content: center;
`;

const Tab = styled.div``;

const StyledRadio = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  border: 1px solid ${COLORS.alto};
  background-color: ${COLORS.white};
  border-radius: 50%;

  :after {
    content: '';
    position: absolute;
    display: none;
    width: 10px;
    height: 10px;
    top: 2px;
    left: 2px;
    background-color: ${COLORS.black};
    border-radius: 50%;
  }
`;

const Label = styled.label`
  font-family: ${FONT_FAMILIES.base};
  font-size: 13px;
  line-height: 16px;
  display: block;
  position: relative;
  padding-left: 23px;
  margin-right: 30px;
  cursor: pointer;
  user-select: none;

  :hover > ${StyledRadio} {
    border-color: ${COLORS.boulder};
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;

  :checked ~ ${StyledRadio}::after {
    display: block;
  }
`;

// eslint-disable-next-line react/prefer-stateless-function
export default class ListTabs extends PureComponent {
  handleTabChange = tab => () => {
    this.props.onTabChange(tab);
  };

  render() {
    const { className, defaultCheck, t } = this.props;

    return (
      <Wrapper className={className}>
        {Object.keys(TABS).map((tab, index) => {
          const key = `ListTab_${index}`;
          const onChange = this.handleTabChange(tab);
          const isChecked = defaultCheck === tab;

          return (
            <Tab key={key}>
              <Label htmlFor={tab}>
                <Input
                  name="ListTab"
                  id={tab}
                  type="radio"
                  value={tab}
                  onChange={onChange}
                  defaultChecked={isChecked}
                />
                {t(TABS[tab])}
                <StyledRadio className="radio">&nbsp;</StyledRadio>
              </Label>
            </Tab>
          );
        })}
      </Wrapper>
    );
  }
}
